import * as types from './constants';

// Billing Subscription Upgrade
export const billingSubscriptionUpgradeRequest = data => (
  { type: types.BILLING_SUBSCRIPTION_UPGRADE_REQUEST, payload: data }
);

export const billingSubscriptionUpgradeDone = data => (
  { type: types.BILLING_SUBSCRIPTION_UPGRADE_DONE, payload: data }
);

export const billingSubscriptionUpgradeFailed = errors => (
  { type: types.BILLING_SUBSCRIPTION_UPGRADE_FAILED, payload: errors }
);

export const billingSubscriptionUpgradeReset = () => (
  { type: types.BILLING_SUBSCRIPTION_UPGRADE_RESET }
);